import axios from 'axios';

// export const analysis = {
//     getAnalysisExplanationData() {
//         return axios({
//             method: 'GET',
//             maxBodyLength: Infinity,
//             url: `${process.env.VUE_APP_API}/analysis_explanation`,
//         })
//             .then(function (response) {
//                 return response.data
//             }).catch(() => {
//                 return false
//             });
//     },
// };

export const analysis = {
    getAnalysisExplanationData(lang = 'th') {
      // ตรวจสอบว่า lang เป็น 'en' เท่านั้น ถ้าไม่ใช่ ให้ fallback เป็น 'th'
      const selectedLang = lang === 'en' ? 'en' : 'th';
  
      return axios({
        method: 'GET',
        maxBodyLength: Infinity,
        url: `${process.env.VUE_APP_API}/analysis_explanation?lang=${selectedLang}`,
      })
        .then(response => response.data)
        .catch(() => false);
    },
  };